import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "@mantine/core";
import { useOverlayZIndex } from "./useOverlayZIndex";
/**
 * Drop-in replacement for Mantine's Modal that automatically gets a
 * z-index higher than any previously opened overlay (modal or drawer).
 */
export const AppModal = ({ opened, zIndex, ...rest }) => {
    const autoZIndex = useOverlayZIndex(opened);
    return _jsx(Modal, { opened: opened, zIndex: zIndex ?? autoZIndex, ...rest });
};
